module.exports = __webpack_public_path__ + "img/versionBanner3.ea23d309.jpg";